import React from 'react';
import './SRead.css';

const DisplayStudy = ({ items, currentIndex }) => {
  return (
    <div className="display">
      {items.map((item, index) => (
        <span key={index} className={index === currentIndex ? 'highlight' : ''}>
          {item}
        </span>
      ))}
    </div>
  );
};

export default DisplayStudy;